import { Widget, WidgetSettingType } from '../base/widget/WidgetInterface'
import { WidgetHeightType, WidgetType } from '../base/widget/WidgetTypes'

export const WidgetMessages: Widget = {
  type: WidgetType.messages,
  title: 'Meldungen',
  minSize: 4,
  defaultSize: 32,
  icon: 'Bell',
  defaultHeightType: WidgetHeightType.automatic,
  customSettings: {
    settings: {
      showTitle: { type: WidgetSettingType.checkbox, title: 'Widget Titel anzeigen', checked: false },
      layoutVertical: { type: WidgetSettingType.checkbox, title: 'Vertikales Layout', checked: false },

      message: { type: WidgetSettingType.checkbox, title: 'Mitteilungen anzeigen', checked: true },
      news: { type: WidgetSettingType.checkbox, title: 'Termine anzeigen', checked: true },
      alarms: { type: WidgetSettingType.checkbox, title: 'Alarmierungen anzeigen', checked: true },

      recipients: { type: WidgetSettingType.custom, data: {}, template: 'custom/SettingsPanelCustomCustomMessagesRecipients' }
    },
    sections: [
      {
        label: 'Filter',
        settings: ['alarms', 'message', 'news']
      },
      {
        label: 'Empfänger',
        settings: ['recipients']
      }
    ]
  }
}

export default WidgetMessages
